export const enum StopTypes {
    NormalStop = "NormalStop",
    DoesNotStop = "DoesNotStop",
    PickupOnly = "PickupOnly",
    SetDownOnly = "SetDownOnly",
    RequestStop = "RequestStop",
}
